import React from 'react';

const UserAgreement: React.FC = () => (
  <div style={{ padding: 24, maxWidth: 1000, margin: '0 auto', background: '#fff', borderRadius: 8, lineHeight: 1.6 }}>
    <h1 style={{ textAlign: 'center', marginBottom: 30 }}>达康AI医疗辅助系统用户服务协议</h1>
    
    <div style={{ marginBottom: 20 }}>
      <p>欢迎您注册达康AI医疗辅助系统账号并使用达康AI医疗辅助系统的服务！</p>
      <p>为使用达康AI医疗辅助系统的产品及/或服务，请您仔细认真阅读并遵守本《达康AI医疗辅助系统用户服务协议》（以下简称"本服务协议"）的全部内容。本协议是用户注册达康AI医疗辅助系统账号并使用达康AI医疗辅助系统平台产品及/或服务，或非经注册程序直接使用达康AI医疗辅助系统平台产品及/或服务时的通用条款，请您务必审慎阅读、充分理解本协议各条款内容，特别是免除或者限制责任的条款、管辖与法律适用条款。免除或者限制责任的条款可能以黑体加粗或加下划线的形式提示您重点注意。如您对本协议有任何疑问，可向达康AI医疗辅助系统咨询后，再进行下一步操作。如果您不同意本协议的约定，您应立即停止注册程序或停止使用达康AI医疗辅助系统平台产品及/或服务；如您勾选"我同意《达康AI医疗辅助系统用户服务协议》"并通过注册程序或以其他达康AI医疗辅助系统允许的方式实际使用达康AI医疗辅助系统平台产品及/或服务时，即视为您已确知并完全同意本协议全部条款、《达康AI医疗辅助系统隐私保护政策》《免责声明》的内容并自愿受其约束，届时您不应以未阅读本协议的内容或者未获得达康AI医疗辅助系统对您问询的解答等理由，主张本协议无效，或要求撤销本协议。</p>
      <p><strong>如果您未满18周岁，请务必在家长和其他法定监护人的陪同下阅读本服务协议，并在进行注册、下单、支付等任何行为或使用达康AI医疗辅助系统的其他任何服务前，应事先征得您的家长和其他法定监护人的同意。</strong></p>
    </div>

    <h2>一、协议的主体与范围</h2>
    <h3>1.【签约主体】</h3>
    <p>视您所使用的具体服务而定，"达康AI医疗辅助系统"是指广州市达康经济发展有限公司旗下运营或提供您所使用的相关具体服务的相关主体的统称，您可在相关服务的具体服务条款或说明文件中查看上述主体的名称和信息。"用户"是指使用达康AI医疗辅助系统相关服务的使用人，在本服务协议中更多称呼为"您"。</p>

    <h3>2.【协议内容】</h3>
    <p>本服务协议内容同时包括：</p>
    <ul>
      <li>本《达康AI医疗辅助系统用户服务协议》文本；</li>
      <li>《达康AI医疗辅助系统平台隐私政策》达康AI医疗辅助系统非常重视您的个人信息和隐私的保护，将按照《达康AI医疗辅助系统平台隐私政策》中所公布的政策在具体服务中进行隐私及个人信息的收集、存储、使用、披露等活动。您在注册达康AI医疗辅助系统账号前，应仔细阅读《达康AI医疗辅助系统平台隐私政策》；</li>
      <li>具体服务的服务条款：您的达康AI医疗辅助系统平台账号一经注册，即可凭该账号按规定享受达康AI医疗辅助系统平台上的各项丰富的服务。您在使用具体服务前，应仔细阅读该服务所适用的服务条款；</li>
      <li>专项商品或服务规则。为更好地提升用户体验，达康AI医疗辅助系统将会针对若干具体专项商品或服务中特别制定规则，供各方遵守。</li>
    </ul>

    <h3>3.【协议遵守】</h3>
    <p>您理解并同意：</p>
    <ul>
      <li>上述【协议内容】中所述的协议、政策、条款与规则构成本服务协议不可分割的组成部分，共同适用于您所使用的达康AI医疗辅助系统平台服务。</li>
      <li>根据国家法律法规变化、运营需要或为提升服务质量的目的，达康AI医疗辅助系统将在必要的时候对上述各项协议、条款与规则不时地进行修改更新，并通过在网页或移动客户端上发出公告、站内信等合理、醒目的方式向您进行提前通知。</li>
      <li>您应当及时查阅并了解相关更新修改内容，如您不同意相关更新修改内容，可停止使用相关更新修改内容所涉及的服务。</li>
    </ul>

    <h2>二、账号的注册</h2>
    <h3>1.【注册资料】</h3>
    <p>您应遵循诚实信用、合法善意的原则，向达康AI医疗辅助系统提交相关注册资料，相关注册资料应当遵守法律法规、社会主义制度、国家利益、公民合法权益、公序良俗、信息真实等原则，不应提交任何违法或不良信息，相关资料如有变动，您应及时更新。</p>

    <h3>2.【民事行为能力】</h3>
    <p>您知悉并承诺，您具有完全民事权利能力和行为能力或虽不具有完全民事权利能力和行为能力但已经过您的家长和其他法定监护人同意并由您的家长和其他法定监护人代理注册及使用达康AI医疗辅助系统的各项服务。</p>

    <h3>3.【真实身份】</h3>
    <p>因国家法律法规、监管要求及特定门类的服务需要，您有可能需要在注册或使用该等服务的特定环节中填写真实的身份信息，并需通过相关验证流程后方可使用服务。</p>

    <h3>4.【注册信息保护】</h3>
    <p>达康AI医疗辅助系统将对您所提交的注册信息予以保护，不会将其披露给任何非关联的第三方，除非：</p>
    <ul>
      <li>相关法律法规或国家机关要求；</li>
      <li>达康AI医疗辅助系统发生相关合并、分立、收购或资产转移；</li>
      <li>为提供相关服务所必须的。</li>
    </ul>

    <h2>三、账号的使用</h2>
    <h3>1.【账号登录】</h3>
    <p>您可以使用注册账号时填写登记的并获得系统审核通过的账号密码登录达康AI医疗辅助系统平台。为了您的使用便利，达康AI医疗辅助系统将适时提供指纹识别、人脸识别等更为安全便捷的登录方式。</p>

    <h3>2.【账号使用】</h3>
    <p>您应对您账号项下的所有行为所产生的一切后果负责，通过您的账号所发生的上述各项行为将视为您本人的真实意思表示。</p>

    <h3>3.【账号借用】</h3>
    <p>为保证相关账号安全，未经达康AI医疗辅助系统的书面同意，您不应将达康AI医疗辅助系统平台上所注册的账号借给他人使用，否则您应当承担由此产生的全部责任。</p>

    <h3>4.【安全义务】</h3>
    <p>如您发现账号存在安全问题，请您立即联系达康AI医疗辅助系统予以调查处理。您应该妥善保管您的账号和密码，当您使用完毕达康AI医疗辅助系统的服务后，您应安全退出。</p>

    <h2>四、用户行为规范与责任承担</h2>
    <h3>1.【用户义务】</h3>
    <p>您知悉并承诺，在使用达康AI医疗辅助系统所提供的服务的过程中，您应遵守相关法律法规，不应从事如下违反法律法规的规定，影响正常服务提供或损害他人合法利益的行为：</p>
    <ul>
      <li>不应利用达康AI医疗辅助系统平台或相关服务危害国家安全、破坏政治稳定、泄露国家秘密；</li>
      <li>不应制作、发布、复制、查阅和传播、存储、链接违法信息；</li>
      <li>不应从事危害计算机信息网络安全的活动；</li>
      <li>不应擅自复制和使用网络上未公开和未授权的文件；</li>
      <li>不应私自传播广告信息或以"刷单"等不正当方式帮助他人提升评价；</li>
      <li>不应通过侵犯第三人合法权益、作弊、扰乱系统等手段进行交易或参加活动。</li>
    </ul>

    <h3>2.【责任承担】</h3>
    <p>您违反上述承诺时，达康AI医疗辅助系统有权依据本协议的约定，做出相应处理或终止向您提供服务，且无须征得您的同意或提前通知您。</p>

    <h2>五、知识产权</h2>
    <h3>1.【知识产权】</h3>
    <p>您理解并知悉，除另有书面声明以外，以下信息和内容的知识产权归达康AI医疗辅助系统所有：</p>
    <ul>
      <li>在达康AI医疗辅助系统相关服务中所提供的内容和信息；</li>
      <li>达康AI医疗辅助系统用于提供上述内容和信息的基础设施和平台；</li>
      <li>在达康AI医疗辅助系统提供相关服务中所使用的各项商标、商业形象、商业标识等；</li>
      <li>达康AI医疗辅助系统平台服务的开发、运营、维护等过程中产生的所有数据和信息。</li>
    </ul>

    <h3>2.【用户生成内容】</h3>
    <p>您理解并同意，您在使用达康AI医疗辅助系统提供的服务时上传、提交、存储或发布的内容均由您原创或已获合法授权。您通过达康AI医疗辅助系统上传、提交、存储或发布的任何内容的知识产权归属您或原始著作权人所有。</p>

    <h2>六、服务内容与免责声明</h2>
    <h3>1.【服务内容】</h3>
    <p>本平台为用户提供AI医疗辅助、健康咨询、问答等相关服务。</p>

    <h3>2.【免责声明】</h3>
    <p><strong>重要提示：平台提供的信息仅供参考，不能替代专业医疗建议。请在医疗专业人士指导下进行诊断和治疗。对于任何依据本平台信息进行的医疗决定，平台不承担责任。</strong></p>

    <h2>七、隐私保护</h2>
    <p>平台将严格保护用户的个人信息安全，详见《达康AI医疗辅助系统隐私政策》。我们承诺：</p>
    <ul>
      <li>收集的个人信息将严格按照相关法律法规使用；</li>
      <li>不会未经授权向第三方泄露您的个人信息；</li>
      <li>采用先进的技术手段保护数据安全；</li>
      <li>您有权查询、更正、删除您的个人信息。</li>
    </ul>

    <h2>八、协议的终止</h2>
    <p>本服务协议于以下任一情形下终止：</p>
    <ul>
      <li>达康AI医疗辅助系统有权依据本服务协议约定，收回、注销用户账号；</li>
      <li>在满足条件时，您通过自助服务注销达康AI医疗辅助系统的用户账号；</li>
      <li>达康AI医疗辅助系统根据自身商业安排经过合理的提前通知终止全部服务。</li>
    </ul>

    <h2>九、管辖、法律适用与争议解决</h2>
    <p>本服务协议的成立、生效、履行、解释与纠纷解决，适用中华人民共和国大陆地区法律法规，并且排除一切冲突法规定的适用。</p>
    <p>如您因本服务协议与达康AI医疗辅助系统产生争议纠纷，您同意交由广州市达康经济发展有限公司所在地人民法院受理。</p>

    <h2>十、其他</h2>
    <p>如果本服务协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。</p>
    <p>如您有任何需求，可以通过达康AI医疗辅助系统上客服系统与我们联系并作充分描述，我们将在验证您身份后尽快答复您的需求并尽力解决。</p>

    <div style={{ textAlign: 'center', marginTop: 30, fontSize: '14px', color: '#666' }}>
      <p>本协议最终解释权归达康AI医疗辅助系统所有。</p>
      <p>协议生效日期：2025年7月28日</p>
      <p>最后更新日期：2025年7月28日</p>
    </div>
  </div>
);

export default UserAgreement; 